import { AxiosError } from 'axios'
import { useContext, useState } from 'react'

import { post } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { SettingsContext } from '.'
import { Settings } from './types'

const useUpdateSettings = (onUpdated?: (errors?: AxiosError) => void) => {
  const [inProgress, setInProgress] = useState<boolean>(false)
  const { updateSettings: updateSettingsContext } = useContext(SettingsContext)

  const updateSettings = (settings: Partial<Settings>) => {
    setInProgress(true)
    post('/settings/bulk/', settings, undefined, true)
      .then(() => {
        updateSettingsContext(settings)
        if (onUpdated) onUpdated()
      })
      .catch((errors: AxiosError) => {
        handleApiErrors(errors)
        if (onUpdated) onUpdated(errors)
      })
      .finally(() => {
        setInProgress(false)
      })
  }
  return { updateSettings, inProgress }
}

export default useUpdateSettings
